import type {
  IControlSettingData,
  IDynamicControlSetting,
} from '~/presentation/reports/common/type';

import { EReportControlId, ERFilterKey } from '~/presentation/reports/common/type';
import { getFilterSettingUIs } from '../filter-preset';
import { OPERATOR_IS } from '../../constants';

export function buildPresetForPage(
  defaultPreset: {
    presetData: IControlSettingData;
    presetUI: IDynamicControlSetting;
  },
  locationPath: string | null,
) {
  return {
    presetData: {
      ...defaultPreset.presetData,
      [EReportControlId.FILTER]: {
        value: [ERFilterKey.PAGE],
      },
      [EReportControlId.PAGE_OPERATOR]: {
        value: OPERATOR_IS,
      },
      [EReportControlId.SINGLE_PAGE]: {
        value: locationPath ? locationPath : undefined,
      },
    },
    presetUI: {
      ...defaultPreset.presetUI,
      [EReportControlId.FILTER]: {
        controls: getFilterSettingUIs([ERFilterKey.DATE, ERFilterKey.PAGE]),
      },
    },
  };
}
